<template>
    <div class="cr:w-full">
        <input
            type="range"
            :class="inputClasses"
            :step="step"
            :max="max"
            :min="min"
            v-model="value"
            :style="`background: ${trackColor};`"
            @change="handleChange($event)"
        />

        <div class="cr:w-full cr:flex cr:justify-between">
            <span class="cr:text-sm cr:inline-block">{{ min }}</span>
            <span class="cr:text-sm cr:inline-block">{{ max }}+</span>
        </div>
    </div>
</template>

<script setup lang="ts">
import {computed, ref, watch} from "vue";

const props = defineProps({
    inputClasses: {
        type: Array,
        default: ['cr:w-full']
    },
    min: {
        type: Number,
        default: 0
    },
    max: {
        type: Number,
        default: 100
    },
    step: {
        type: Number,
        default: 5
    },
    modelValue: {
        type: Number,
        default: 10
    }
});

const emit = defineEmits(["update:modelValue"]);
const value = ref(props.modelValue);

const percent = computed(() => (value.value - props.min) / (props.max - props.min) * 100);
const trackColor = computed(() => 'linear-gradient(to right, #00A3FF 0%, #00A3FF ' + percent.value + '%, #F0FAFF ' + percent.value + '%, #F0FAFF 100%)');

const handleChange = (event: any) => {
    emit('update:modelValue', parseFloat(event.target.value));
};

watch(() => props.modelValue, () => {
    if(value.value !== props.modelValue)
        value.value = props.modelValue;
});

watch(value, () =>  emit('update:modelValue', parseFloat(value.value.toString())));
</script>